/**
 * Training Mode route → topic slug mapping.
 *
 * Drives the "Train me on this page" quick action (button + ⌘K/Ctrl+K
 * shortcut when Training Mode is ON). The resolver returns the best-fit
 * topic slug for the current URL so the picker can auto-open that topic.
 *
 * Match order (first hit wins):
 *   1. Exact path match
 *   2. startsWith prefix match (for /lead-focus/:id etc.)
 *   3. Fallback: navigate-crm (§1B universal baseline)
 *
 * Keep this map in sync with the seed in
 * `/app/backend/training_topics_seed.json`.
 */
export const ROUTE_TOPIC_MAP = [
  { match: "/dashboard", slug: "navigate-crm" },
  { match: "/contacts", slug: "view-lead-full-profile" },
  { match: "/leads", slug: "search-filter-leads" },
  { match: "/lead-focus", slug: "view-lead-full-profile", prefix: true },
  { match: "/contact/", slug: "view-lead-full-profile", prefix: true },
  { match: "/add-lead", slug: "add-lead-manually" },
  { match: "/communications", slug: "manage-tasks-comms" },
  { match: "/calendar", slug: "manage-demo-calendar" },
  { match: "/demo-bookings", slug: "schedule-demo" },
  { match: "/dialer", slug: "start-calling-campaign" },
  { match: "/quotes/new", slug: "build-send-quote" },
  { match: "/quotes", slug: "build-send-quote", prefix: true },
  { match: "/contracts/new", slug: "generate-contract" },
  { match: "/resources", slug: "learning-paths-on-call" },
  { match: "/ai-agents", slug: "understand-ai-agents" },
  { match: "/reports", slug: "view-pipeline-reports" },
  { match: "/settings", slug: "update-profile" },
  { match: "/", slug: "navigate-crm" },
];

export function resolveTopicForPath(pathname) {
  if (!pathname) return "navigate-crm";
  // Exact matches first
  for (const entry of ROUTE_TOPIC_MAP) {
    if (!entry.prefix && entry.match === pathname) return entry.slug;
  }
  // Prefix matches
  for (const entry of ROUTE_TOPIC_MAP) {
    if (entry.prefix && pathname.startsWith(entry.match)) return entry.slug;
  }
  // Root
  if (pathname === "/") return "navigate-crm";
  return "navigate-crm";
}
